import React from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { usePermissions } from '../../../hooks/usePermissions';
import { CREATE_PURCHASE_INVOICE, CREATE_SALE_INVOICE } from '../../../constants/eInvoicePermissions';
import { useAccessDeniedMessage } from '../../../hooks/useAccessDeniedMessage';
import PermissionDeniedWrapper from '../../../components/PermissionDeniedWrapper';

function InvoiceListPageActions({ isPurchase = false }) {
  const navigate = useNavigate();
  const { hasEInvoicePermission } = usePermissions();
  const accessDeniedMessage = useAccessDeniedMessage();
  const createPermission = isPurchase ? CREATE_PURCHASE_INVOICE : CREATE_SALE_INVOICE;
  const canCreate = hasEInvoicePermission(createPermission);

  const handleClick = () => {
    navigate(
      isPurchase ? "/purchases/invoices/create" : "/sales/invoices/create",
    );
  };

  return (
      <PermissionDeniedWrapper show={!canCreate} title={accessDeniedMessage}>
        <Button
          id="create-invoice"
          variant="contained"
          color="primary"
          onClick={handleClick}
          disabled={!canCreate}
        >
          {isPurchase ? "+ Create self billed Invoice" : "+ Create Invoice"}
        </Button>
      </PermissionDeniedWrapper>
  );
}

export default InvoiceListPageActions;
